import { useWidgetContext } from 'widgets/WidgetContext';
import { useDispatch } from 'store/hooks';
import { useEffect } from 'react';
import { myPortfolioCapsulesInitialise } from 'widgets/myPortfolioCapsules/store/actions';

export function useInitialiseMyPortfolioCapsulesWidget() {
    const { widgetKey } = useWidgetContext();
    const dispatch = useDispatch();
    return useEffect(() => {
        dispatch(myPortfolioCapsulesInitialise(widgetKey));
    }, [widgetKey, dispatch]);
}
